import './styles/main.css';
import { GameClient } from './net/GameClient';
import { store, type AppState } from './state/store';
import { createToaster } from './ui/components/toast';
import { HomeScreen } from './ui/screens/HomeScreen';
import { LobbyScreen } from './ui/screens/LobbyScreen';
import { TournamentScreen } from './ui/screens/TournamentScreen';
import type { Screen } from './ui/screens/types';

type ScreenKind = 'home' | 'lobby' | 'tournament';

function screenKind(state: AppState): ScreenKind {
  if (!state.session || !state.room) return 'home';
  return state.tournament ? 'tournament' : 'lobby';
}

function bootstrap(): void {
  const root = document.getElementById('app');
  if (!root) throw new Error('Conteneur #app introuvable');

  const toasts = document.createElement('div');
  toasts.className = 'toasts';
  toasts.setAttribute('aria-live', 'polite');
  document.body.appendChild(toasts);
  const notify = createToaster(toasts);

  const client = new GameClient(store);
  client.onKicked = () => notify("Vous avez été exclu du salon par l'hôte.", 'error');

  let current: { kind: ScreenKind; screen: Screen } | null = null;

  const render = (state: AppState): void => {
    const kind = screenKind(state);
    if (current?.kind !== kind) {
      current?.screen.destroy();
      const screen =
        kind === 'home'
          ? new HomeScreen(client)
          : kind === 'lobby'
            ? new LobbyScreen(client, notify)
            : new TournamentScreen(client);
      root.replaceChildren(screen.element);
      current = { kind, screen };
    }
    current.screen.update(state);
  };

  store.subscribe(render);
  render(store.get());
}

bootstrap();
